<template>
  <div>
    <div class="last-changes rounded-lg container">
      <h2 class="text-center mb-3">گزارش ورود و خروج کاربران</h2>
        <v-data-table
            dense
            :loading="loading_tickets"
            :headers="users_activity_table.headers"
            :items="users_activity_table.desserts"
            :items-per-page="100"
            hide-default-footer
            class="elevation-0"
        >

          <template v-slot:item.action="{ item }">
            <v-chip class="lighten-5 my-4 text-black" :color="item.action==='login'?'success':'red'">
                {{item.action==='login'?'ورود':'خروج'}}
            </v-chip>
          </template>


          <template v-slot:item.des="{ item }">
            <v-tooltip v-if="item['des']&&item['des'].length>50" top color="gray" max-width="50em">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs"
                   v-on="on">
                  {{item.des.slice(0,30)+'...'}}
                </div>
              </template>
              {{item.des}}
            </v-tooltip>
            <div v-else>
              {{item.des}}
            </div>
          </template>

          <template v-slot:item.user="{ item }">
              {{item.user["get_full_name"]}}
          </template>
          <template v-slot:item.timestamp="{ item }">
            <v-tooltip top color="red">
              <template v-slot:activator="{ on, attrs }">
                <a v-bind="attrs" v-on="on">
                  {{ new Date(item.timestamp.split('T')[0]).toLocaleDateString('fa-IR') }}
                </a>
              </template>
              <span>{{ convert_en_to_fa_number(item.timestamp.split('T')[1].split('.')[0]) }}</span>
            </v-tooltip>
          </template>


        </v-data-table>
        <v-row>
          <v-col>
            <v-pagination
                v-if="users_activity_count > 20"
                v-model="page"
                color="#D20003"
                rounded
                @input="get_users_activity()"
                :length="users_activity_count%20!==0?parseInt(users_activity_count/20)+1:parseInt(users_activity_count/20)"
                :total-visible="7"
            ></v-pagination>
          </v-col>
          <v-col cols="1">
            <v-select 
            v-model="page_size"
            :items="[10, 20, 50, 100]"
            @change="get_users_activity"
            >
            </v-select>
          </v-col>
        </v-row>
      </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'UserActivity',
  data:()=>({
    key: localStorage.getItem('key'),
    loading_tickets: false,
    search_field:null,
    users_activity_count:0,
    page:1,
    page_size:20,
    users_activity_table: {
      headers: [
        {text: 'کاربر',align: 'center', value: 'user', sortable: true},
        {text: 'زمان',align: 'center', value: 'timestamp', sortable: true},
        {text: 'عملیات',align: 'center', value: 'action', sortable: false},
        {text: 'توضیحات',align: 'center', value: 'des', sortable: false},
      ],
      desserts:[],
    },
    show_detail:false,
    contact_detail:{},
    is_read_btn_loading:false,
  }),
  created() {
    this.get_users_activity();
    setInterval(()=>{
      this.get_users_activity();
    }, 10000)
  },
  methods:{
    get_users_activity(){
      this.loading_tickets = true;
      axios
            .get(`${this.BACKEND_LINK}/api/account/users-activity?page_size=${this.page_size}&page=${this.page}`,{
              headers: {'Authorization': `Token ${this.key}`}
            })
            .then((response)=>{
              if (response.data){
                this.users_activity_count = response.data.count;
                this.users_activity_table.desserts = response.data.results;
              }
            })
            .catch((errors)=>{
              this.$snotify.error(`مشکلی پیش آمد کد : ${errors.response.status}`, 'فیلتر')
            })
            .finally(()=>{
              this.loading_tickets = false;
            })
    },
  }
}
</script>
